import { Component, OnInit } from '@angular/core';
import { PaylocService } from '../services/payloc.service';

@Component({
  selector: 'app-payloc-list',
  templateUrl: './payloc-list.component.html',
  styleUrls: ['./payloc-list.component.css']
})
export class PaylocListComponent implements OnInit {

  paylocs$ = this.service.data$;
  public isRowsViewSelected = true;
  public isCardsViewSelected = false;

  constructor(
    private service: PaylocService
  ) { }

  ngOnInit() {
  }

  public onSearchClicked(page: number): void {
    this.displayFilterTokens();
    this.service.getPaylocs(page);
    window.scroll(0, 0);
  }

  public onClearFiltersClicked(): void {
    this.service.resetFilters();
    this.service.hasSearched = false;
    this.service.hasSearchResults = false;
    this.service.hasFilterTokens = false;
    this.service.getPaylocs(1);
  }

  public onFilterTokenClicked(filterToken: any): void {
    this.removeFilterToken(filterToken);
  }

  private removeFilterToken(filterToken: any): void {
    const index = this.service.filterTokens.findIndex(token => token.name === filterToken.name);

    if (index !== -1) {
      const token = this.service.filterTokens[index];
      this.service.paylocSearch[token.obj] = null;
      this.service.filterTokens.splice(index, 1);
      this.service.canSearchFn();
      this.service.getPaylocs(1);
    }
  }

  private displayFilterTokens(): void {
    this.service.displayFilterTokens();
  }

}
